import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";

const UserDownloadLisr = () => {
  return (
    <div className="bg-[#f0ece1] fixed_width">
      <div>
        <AdminHeader />
        <AdminNavbar />
        <div className="  container  h-[100vh] ">
          <div className="flex justify-between items-center">
            <div className="mt-3 relative ">
              <input
                type="text"
                placeholder="Find Member..."
                className="w-[270px] py-2  border-1 border-gray-400 ml-1"
              />
              <button className="border-none absolute left-[190px] top-[8px] bg-orange-300 font-bold  py-[1px] px-3">
                Search
              </button>
              <label htmlFor="" className="mr-2">
                Status
              </label>
              <select
                name=""
                id=""
                className="w-[120px] py-2  border-1 border-gray-400"
              >
                <option value="">Active</option>
                <option value="">Suspend</option>
                <option value="">Locked</option>
                <option value="">All</option>
              </select>
            </div>

            <div className="add_memeber">
              <button className="w-[120px] py-1 border-1  border-gray-400">
                Add User
              </button>
            </div>
          </div>
          <div className="w-[100%] bg-[#f0ece1] border-b-2 border-[#498daf] shadow-md  flex  justify-center">
            <div className="user_list mt-4  flex justify-between w-[100%] px-3 py-2 bg-[#fff]">
              <div>
                <h2 className="text-gray-400 text-[14px]">Total Balance</h2>
                <span className=" font-bold text-black">PBU 7.90</span>
              </div>
              <div>
                <h2 className="text-gray-400 text-[14px]">Total Balance</h2>
                <span className=" font-bold text-black">PBU 7.90</span>
              </div>
              <div>
                <h2 className="text-gray-400 text-[14px]">Total Balance</h2>
                <span className=" font-bold text-black">PBU 7.90</span>
              </div>
              <div>
                <h2 className="text-gray-400 text-[14px]">Total Balance</h2>
                <span className=" font-bold text-black">PBU 7.90</span>
              </div>
              <div>
                <h2 className="text-gray-400 text-[14px]"> Total Balance</h2>
                <span className=" font-bold text-black">PBU 7.90</span>
              </div>
              <div>
                <h2 className="text-gray-400 text-[14px]">Total Balance</h2>
                <span className=" font-bold text-black">PBU 7.90</span>
              </div>
            </div>
          </div>
          <div className="flex mb-[60px]  mt-3 flex-col">
            <div className="overflow-x-auto">
              <div className=" w-full inline-block align-middle">
                <div className="overflow-hidden border border-black">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-300 text-[#3c505a]">
                      <tr>
                        <th
                          scope="col"
                          colspan="4"
                          className="px-6 py-3 text-xs font-bold text-left  uppercase "
                        >
                          Account
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-left  uppercase "
                        >
                          Credit Ref.
                        </th>
                        <th
                          scope="col"
                          colspan="1"
                          className="px-4 py-3 text-xs font-bold text-left  uppercase "
                        >
                          Balance
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-left  uppercase "
                        >
                          Exposure
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-right  uppercase "
                        >
                          Avail. bal.
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-right  uppercase "
                        >
                          Exposure Limit
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-right  uppercase "
                        >
                          Ref. P/L
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-right  uppercase "
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-right  uppercase "
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y bg-[#fff] divide-gray-200">
                      {[...Array(30)].map(() => {
                        return (
                          <tr className="border-bottom-1 border-gray-300">
                            <td
                              colspan="4"
                              className="px-6 py-4 text-sm font-medium text-gray-800 whitespace-nowrap"
                            >
                              <div>
                                <span className="bg-yellow-400 text-[13px] rounded-[5px] mr-2 px-[10px] py-[0px]]">
                                  PL
                                </span>
                                <span className="">simul11</span>
                              </div>
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
                              <a href="#" className="text-blue-400">
                                0.12
                              </a>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-800 whitespace-nowrap">
                              0.00{" "}
                              <span className="bg-blue-400 text-center rounded py-[1px] px-1 text-white font-bold">
                                +
                              </span>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-800 whitespace-nowrap">
                              <span className="px-4 py-1 text-red-500 bg-red-200 font-bold border-1 border-red-400">
                                0.00
                              </span>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-800 whitespace-nowrap">
                              0.00
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-800 whitespace-nowrap">
                              1,000.00
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-800 whitespace-nowrap">
                              0.00
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-800 whitespace-nowrap">
                              <button className="px-3 py-1 border-1 border-green-400 bg-green-100 font-bold text-green-700">
                                Active
                              </button>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-800 whitespace-nowrap">
                              <div className="flex  justify-end">
                                <img
                                  src="./img/Profit&Loss_Icon.png"
                                  alt=""
                                  className="w-[40px] border-[0.7px] mr-2 hover:shadow-md cursor-pointer hover:bg-gray-200 bg-gray-100 border-gray-300 px-2 py-[5px]"
                                />
                                <img
                                  src="./img/History_Icon.png"
                                  alt=""
                                  className="w-[40px] border-[0.7px] mr-2 hover:shadow-md cursor-pointer hover:bg-gray-200 bg-gray-100 border-gray-300 px-2 py-[5px]"
                                />

                                <img
                                  src="./img/Settings_Icon.png"
                                  alt=""
                                  className="w-[40px] border-[0.7px] mr-2 hover:shadow-md cursor-pointer hover:bg-gray-200 bg-gray-100 border-gray-300 px-2 py-[5px]"
                                />
                                <img
                                  src="./img/Profile_Icon.png"
                                  alt=""
                                  className="w-[40px] border-[0.7px] mr-2 hover:shadow-md cursor-pointer hover:bg-gray-200 bg-gray-100 border-gray-300 px-2 py-[5px]"
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="footerpart   bg-[#ecf5fc]">
            <div className=" flex py-2 justify-end">
              <div className="flex items-center">
                <img
                  src="./img/Bank_Icon.png"
                  className="w-[40px] border-[0.7px] mr-2 hover:shadow-md cursor-pointer hover:bg-gray-200 bg-gray-100 border-gray-300 px-2 py-[5px]"
                  alt=""
                />
                <span className="mr-3 text-[14px]">Bank</span>
                <img
                  src="./img/Profit&Loss_Icon.png"
                  className="w-[40px] border-[0.7px] mr-2 hover:shadow-md cursor-pointer hover:bg-gray-200 bg-gray-100 border-gray-300 px-2 py-[5px]"
                  alt=""
                />
                <span className="mr-3 text-[14px]">Betting Profit & Loss</span>
                <img
                  src="./img/History_Icon.png"
                  className="w-[40px] border-[0.7px] mr-2 hover:shadow-md cursor-pointer hover:bg-gray-200 bg-gray-100 border-gray-300 px-2 py-[5px]"
                  alt=""
                />
                <span className="mr-3 text-[14px]">History</span>
                <img
                  src="./img/Profile_Icon.png"
                  className="w-[40px] border-[0.7px] mr-2 hover:shadow-md cursor-pointer hover:bg-gray-200 bg-gray-100 border-gray-300 px-2 py-[5px]"
                  alt=""
                />
                <span className="mr-3 text-[14px]">Profile</span>
                <img
                  src="./img/Settings_Icon.png"
                  className="w-[40px] border-[0.7px] mr-2 hover:shadow-md cursor-pointer hover:bg-gray-200 bg-gray-100 border-gray-300 px-2 py-[5px]"
                  alt=""
                />
                <span className="mr-3 text-[14px]">Change Status</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDownloadLisr;
